/**
 * uploadRemoval.js — remove an uploaded file for real (Lane 1430).
 *
 * One backend function sits behind all three calls
 * (backend/helpers/upload_removal.py remove_upload). Resolves the parsed JSON
 * body, or throws an Error carrying `.status` and `.detail` (the server's
 * plain-English sentence). 404: not found or another company's file.
 * 409: still being read. 503: nothing was changed.
 */

import { API_BASE } from '../config';

function authHeader() {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function request(method, path) {
  const res = await fetch(`${API_BASE}${path}`, { method, headers: { ...authHeader() } });
  let body = null;
  try {
    body = await res.json();
  } catch (_) {
    body = null;
  }
  if (!res.ok) {
    const detail = body && typeof body.detail === 'string' ? body.detail : '';
    const err = new Error(`upload removal ${method} ${path} failed: ${res.status} ${detail}`);
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return body;
}

/** A company user removes one of their company's uploads. */
export function removeUpload(candidateId) {
  return request('DELETE', `/api/chat/upload/candidates/${encodeURIComponent(candidateId)}`);
}

/** Admin: every upload of one company, plus recent removals. */
export function listCompanyUploads(companyId) {
  return request('GET', `/api/admin/companies/${encodeURIComponent(companyId)}/uploads`);
}

/** Admin: remove one upload of that company. */
export function adminRemoveUpload(companyId, candidateId) {
  return request(
    'DELETE',
    `/api/admin/companies/${encodeURIComponent(companyId)}/uploads/${encodeURIComponent(candidateId)}`,
  );
}

/** The plain sentence shown when a removal fails. */
export function removalErrorText(err) {
  if (err && err.detail) return err.detail;
  return 'The file could not be removed. Try again.';
}
